import Styles from "./project.module.css";
import useMediaQuery from "../../hooks/use-media-query";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../Layout/header";
import Axios from "axios";
import { Button } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import parse from "html-react-parser";

const Projetcs = () => {
  const isMobile = useMediaQuery(991);
  const params = useParams();

  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);
  const pageSize = 10;

  async function fetchProjects(page = 1) {
    setIsLoading(true);
    try {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `https://ap.roboarmy.in/api/project/?page_size=${pageSize}&page=${page}`,
        headers: {},
      };

      const response = await Axios.request(config);

      // Handle the new paginated response structure
      if (response.data.results && response.data.results.payload) {
        const sortedData = response.data.results.payload.sort(
          (a, b) => a.id - b.id
        );
        setdata(sortedData);
        setTotalCount(response.data.count);
        setHasNext(!!response.data.next);
        setHasPrevious(!!response.data.previous);
      } else {
        // Fallback for old API structure
        const sortedData = response.data.payload.sort((a, b) => a.id - b.id);
        setdata(sortedData);
      }

      setCurrentPage(page);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchProjects(1);
  }, []);

  const handleNextPage = () => {
    if (hasNext) {
      fetchProjects(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (hasPrevious) {
      fetchProjects(currentPage - 1);
    }
  };

  if (isLoading) {
    return <div>Loading</div>;
  }
  return (
    <div>
      <Header />
      <div className={Styles.container}>
        {data.map((item, index) => {
          return (
            <div
              className={Styles.card}
              style={{ display: isMobile ? "block" : "" }}
            >
              <img
                src={`https://roboarmythumbnail.s3.ap-south-1.amazonaws.com/project/${item.id}.png`}
                alt="Logo"
                style={{
                  width: isMobile ? "100%" : 350,
                  height: isMobile ? "70%" : 200,
                  borderRadius: 16,
                }}
              />
              <div className={Styles.cardHeading}>
                {`${item.project_name}`}
                <p style={{ fontWeight: "normal", paddingTop: 20 }}>
                  {parse(item.description)}
                </p>
                <Button
                  type="primary"
                  shape="round"
                  icon={<PlayCircleOutlined />}
                  size={"large"}
                  onClick={() => {
                    navigate(`/project/${item.id}`);
                  }}
                >
                  Watch now
                </Button>
                {/* View Kit CTA */}
                <Button
                  type="default"
                  shape="round"
                  size={"large"}
                  style={{ marginLeft: 12, marginTop: 12 }}
                  onClick={() => {
                    navigate(`/kit/${item.primary_kit.id}`);
                  }}
                >
                  View Kit
                </Button>
              </div>
            </div>
          );
        })}

        {/* Pagination Controls */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 20,
            marginTop: 40,
            paddingBottom: 40,
          }}
        >
          <Button
            type="default"
            disabled={!hasPrevious}
            onClick={handlePreviousPage}
            size="large"
          >
            Previous
          </Button>

          <span
            style={{
              fontSize: 16,
              fontWeight: 500,
              color: "#212949",
            }}
          >
            Page {currentPage} of {Math.ceil(totalCount / pageSize)}
          </span>

          <Button
            type="primary"
            disabled={!hasNext}
            onClick={handleNextPage}
            size="large"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Projetcs;
